import React, { useEffect } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import "./pendingfile.scss";
import { getPendingBatchesList } from "../redux/shared/actions";
import DashboardTableSkaleton from "./Skeletons/DashboardTableSkaleton";
import Label from "./Label/Label";

function PendingFiles({ openFileStatusDialog, setOpenFileStatusDialog, list }) {
  const dispatch = useDispatch();

  const apiStatus = useSelector((state) => state?.shared?.apiStatus);

  useEffect(() => {
    dispatch(getPendingBatchesList({}));
  }, [dispatch]);

  return (
    <Dialog
      open={openFileStatusDialog}
      onClose={() => setOpenFileStatusDialog(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{padding:"10px 0px 0px 25px", margin:"0px"}}>Pending Items</DialogTitle>
      <DialogContent>
        <Box>
          <Grid container>
            <Grid item xs={12}>
              <Box>
                {apiStatus?.loader ? (
                  <DashboardTableSkaleton />
                ) : (
                    <TableContainer
                      className="pending-files-table-container"
                      style={{ maxHeight: "72vh", overflowY: "auto" }}
                    >
                      <Table stickyHeader aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" className="index-cell">
                              Index
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              Project Name
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              Batch Name
                            </TableCell>
                            <TableCell
                              className="table-header-title"
                              align="left"
                            >
                              Updated on
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {list.length >= 0 &&
                            list.map((item, index) => (
                              <TableRow key={item.id} className="row-wrap">
                                <TableCell align="center">
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className="data-padding-left"
                                >
                                  {item.project_name}
                                </TableCell>
                                <TableCell align="left">
                                  {item.batch_name}
                                </TableCell>
                                <TableCell align="left">
                                  {item.updated_on}
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                )}
                {list.length === 0 && (
                  <div className="no-data">
                    <Label
                      text="No Data Found"
                      fontSize="16"
                      fontWeight="600"
                      padding="20px"
                    />
                  </div>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenFileStatusDialog(false)} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PendingFiles;
